import axios from 'axios';

export default {
  getPage(permalink, succ) {
    const link = `${permalink}_${localStorage.getItem('lang')}`;
    axios.get(`/pages/${link}`).then((response) => {
      succ(response.data);
    });
  },
};



// WEBPACK FOOTER //
// ./src/api/v1/pages.js